export const MAX_FAVORITE_FILTERS = 5;
